<template>
  <b-row>
    <b-col cols="12" md="3">
      <FormulateInput
        class="p-0"
        name="template_ids"
        label="Nama Template"
        placeholder="Masukkan template"
        validation="required"
        type="value-help-v2"
        trackBy="id"
        displayedBy="name"
        :help="true"
        :disabled="isLoading"
        :listGetter="listGetter"
        :tableFields="tableFields"
        :fullObject="fullObjects"
        @update:fullObject="$emit('update:fullObjects', $event)"
      />
    </b-col>

    <b-col class="my-4">
      <McButton
        variant="secondary"
        text="Lihat Template"
        icon="icon-outline_external-link"
        iconPosition="right"
        :disabled="isLoading || fullObjects?.id === undefined"
        @click="handleClickRedirect"
      />
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'

import McButton from '@/components/McButton'
import TemplateNameCol from './TemplateNameCol'
import TemplateRedirectBtn from './TemplateRedirectBtn'

import * as TemplateDeliveryOrder from '@/services/rest-api/lib/delivery/template'

export default {
  components: {
    McButton,
  },
  inject: ['isLoading'],
  props: {
    fullObjects: {},
  },
  emits: ['update:fullObjects'],
  computed: {
    listGetter() {
      return TemplateDeliveryOrder.get()
    },
    tableFields() {
      return [
        {
          label: 'Nama Template',
          key: 'name',
          name: 'name',
          isSortable: true,
          isSlot: true,
          slotComponent: TemplateNameCol,
        },
        {
          label: 'Target Diambil',
          key: 'expected_pickup_on_interval',
          formatValue: this.formatValue,
          isSortable: true,
        },
        {
          label: 'Target Terkirim',
          key: 'expected_delivered_on_interval',
          formatValue: this.formatValue,
          isSortable: true,
        },
        {
          label: '',
          key: 'redirect-btn',
          name: 'redirect-btn',
          isSlot: true,
          slotComponent: TemplateRedirectBtn,
        },
      ]
    },
  },
  methods: {
    formatValue(value) {
      if (value === null) return

      const duration = moment.duration(value)
      
      const days = duration.get('days')
      const hours = duration.get('hours')
      
      if (days == 0 && hours == 0) {
        return ''
      }

      let formattedValue = '+ '
      
      if (days != 0) {
        formattedValue += `${days} Hari `
      }
      
      if (hours != 0) {
        formattedValue += `${hours} Jam`
      }

      return formattedValue
    },

    handleClickRedirect() {
      if (this.fullObjects?.id === undefined) return

      const routeData = this.$router.resolve({
        name: 'Setting Template Delivery Order Detail',
        params: { id: this.fullObjects.id },
      })

      window.open(routeData.href, '_blank').focus()
    },
  },
}
</script>
